import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }
  
  clearObject(obj:any, allowedProperties:string[]): any {
    var finalObj = JSON.parse(JSON.stringify(obj));
    for (let [key, value] of Object.entries(finalObj)) {
      if(allowedProperties.indexOf(key)<0 && typeof value === 'object'){
        //es object y NO esta permitido incluirlo
        delete finalObj[key];
      }else if(typeof value === 'object'){
        //es object y esta permitido incluirlo
        if(Array.isArray(value)){
          for(let i = 0 ; i < value.length ; i++){
            finalObj[key][i] = this.clearObject(value[i], allowedProperties);
          }
        }else{
          finalObj[key] = this.clearObject(value, allowedProperties);
        }
      }
    }
    return finalObj;
  }

  randomString(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-$!?+98/\|#*';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

}
